<template>
  <c-model ref="importContentModel" :title="title" width="60%" @confirm="importSubmit">
    <div class="other_content">
      <slot name="other"></slot>
    </div>
    <el-upload
      :http-request="uploadFiles"
      class="upload_content"
      ref="upload"
      action="'' "
      :multiple="false"
      accept="csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :file-list="fileList"
    >
      <el-button size="small" type="primary">选择文件</el-button>
    </el-upload>
    <div class="el-upload__tip">只能上传application/vnd.ms-excel文件，且最多上传一个</div>
  </c-model>
</template>

<script>
export default {
  props: {
    title: String
  },
  data() {
    return {
      fileList: [],
      formData: null
    }
  },
  methods: {
    // 自定义上传
    uploadFiles(data) {
      console.log('上传')
      const fileInfo = {
        name: data.file.name
      }
      console.log(data)
      let formData = new FormData()
      formData.append('file', data['file'])
      this.fileList = [fileInfo]
      this.formData = formData
      //   this.$emit('finished',formData)
    },
    open() {
      this.$refs.importContentModel.open()
    },
    close() {
      this.$refs.importContentModel.close()
      //清空文件
      this.fileList = []
      this.formData = null
    },
    importSubmit() {
      const { formData, fileList } = this
      if (fileList.length === 0) {
        this.$message.warning('请先选择导入文件')
        return false
      }
      this.$emit('finished', formData)
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    }
  }
}
</script>

<style lang="scss">
.other_content {
  margin-bottom: 20px;
  //   border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}
.upload_content {
  overflow: hidden;
  margin :global {
    .el-upload__tip {
      color: #999;
    }
  }
}
.custom_class {
  float: left !important;
}
</style>
